import { Card, Stack, SxProps, Theme } from '@mui/material';
import { FC, PropsWithChildren, ReactNode } from 'react';

export interface SectionBlockProps {
  title?: ReactNode;
  description?: ReactNode;
  withCard?: boolean;
  sx?: SxProps<Theme>;
}

export const SectionBlock: FC<PropsWithChildren<SectionBlockProps>> = ({
  title,
  description,
  withCard = false,
  children,
  sx,
}) => {
  const header = (
    <Stack gap={0.5}>
      {title}
      {description}
    </Stack>
  );

  if (withCard) {
    return (
      <Card data-scope sx={sx}>
        <Stack gap={1.5} px={2.5} pt={2.5}>
          {header}
        </Stack>
        {children}
      </Card>
    );
  }

  return (
    <Stack data-scope sx={sx}>
      {header}
      {children}
    </Stack>
  );
};
